import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth.jsx";
import { confirmPayment } from "../lib/payments.js";

// Renders for /pay/success and /pay/fail paths (Toss redirects here after
// the user finishes the payment flow). On success we POST the
// paymentKey/orderId/amount to our server for Toss confirmation, then
// redirect to the case status screen via hash routing.
export default function PayReturn({ mode }) {
  const { loading: authLoading, session } = useAuth();
  const [state, setState] = useState({ phase: "working", message: null });

  useEffect(() => {
    if (authLoading) return;
    if (!session) {
      setState({ phase: "error", message: "세션이 만료됐어요. 다시 로그인해주세요." });
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const caseId = params.get("case_id");
    const kind = params.get("kind"); // 'package' for 패키지 충전, null이면 legacy once

    if (mode === "fail") {
      const code = params.get("code");
      const msg = params.get("message");
      setState({
        phase: "error",
        message: msg
          ? `${msg}${code ? ` (${code})` : ""}`
          : "결제가 취소되었어요",
      });
      return;
    }

    const paymentKey = params.get("paymentKey");
    const orderId = params.get("orderId");
    const amount = params.get("amount");

    if (!paymentKey || !orderId || !amount) {
      setState({ phase: "error", message: "결제 정보가 누락됐어요" });
      return;
    }

    (async () => {
      try {
        const result = await confirmPayment({ orderId, paymentKey, amount: parseInt(amount, 10) });
        if (kind === "package") {
          // 패키지 충전 — credit pool에 적립됨. 홈으로 돌아가면 배지가 갱신됨.
          const credits = result?.package_credits;
          setState({
            phase: "success",
            message: credits
              ? `분석권 ${credits}회가 충전됐어요`
              : "분석권이 충전됐어요",
          });
          return;
        }
        // legacy once 플로우: 케이스가 received로 전이됐으니 홈에서 active card로 보임
        window.history.replaceState(null, "", `${window.location.origin}/#`);
        window.location.reload();
      } catch (err) {
        setState({ phase: "error", message: err.message ?? "결제 승인 실패" });
      }
    })();
  }, [authLoading, session, mode]);

  const goHome = () => {
    // pathname을 `/pay/success`에서 `/`로 바꾸려면 navigate가 필요.
    // location.href 직후 reload는 race condition으로 현재 URL을 다시 로드할 수 있어
    // replace로 한 번에 처리한다 (history도 깔끔하게).
    window.location.replace(`${window.location.origin}/`);
  };

  return (
    <div className="app-shell" style={{display:'flex',alignItems:'center',justifyContent:'center',padding:28}}>
      <div style={{textAlign:'center',maxWidth:340}}>
        {state.phase === "working" && (
          <>
            <div className="spinner" style={{margin:'0 auto 16px'}}/>
            <div style={{fontSize:15,fontWeight:700,color:'#1a1a2e'}}>
              결제 확인 중이에요...
            </div>
            <div style={{fontSize:12,color:'#718096',lineHeight:1.7,marginTop:6}}>
              잠시만 기다려주세요.
            </div>
          </>
        )}
        {state.phase === "success" && (
          <>
            <div style={{fontSize:42,marginBottom:10}}>🎟</div>
            <div style={{fontSize:16,fontWeight:800,color:'#1a1a2e',marginBottom:8}}>
              결제가 완료됐어요
            </div>
            {state.message && (
              <div style={{fontSize:13,color:'#4a5568',lineHeight:1.75,marginBottom:20}}>
                {state.message}
              </div>
            )}
            <button onClick={goHome} className="btn btn-primary btn-block">
              홈으로 돌아가기
            </button>
          </>
        )}
        {state.phase === "error" && (
          <>
            <div style={{fontSize:42,marginBottom:10}}>
              {mode === "fail" ? "🚫" : "⚠️"}
            </div>
            <div style={{fontSize:16,fontWeight:800,color:'#1a1a2e',marginBottom:8}}>
              {mode === "fail" ? "결제가 완료되지 않았어요" : "결제 확인에 실패했어요"}
            </div>
            {state.message && (
              <div style={{fontSize:12,color:'#4a5568',lineHeight:1.75,marginBottom:20}}>
                {state.message}
              </div>
            )}
            <button onClick={goHome} className="btn btn-primary btn-block">
              홈으로 돌아가기
            </button>
          </>
        )}
      </div>
    </div>
  );
}
